export const CURRENTLY_BUYING = 'currentlyBuying';
export const WERE_BUYING = 'wereBuying';
export const NOT_BUYING = 'notBuying';
